let errorFields: { [id: string]: boolean } = {}

export default errorFields
